<p>{{this.partialResults}} of {{this.collectionSize}} records</p>
<span><b>Results per page: </b></span>
<!--"col2 d-grid gap-2 d-md-flex justify-content-md-start align-items-start"-->
&nbsp;&nbsp;<app-st-select-short [idVal]="this.idVal + '-page-size-dropdown-list-id'" [defaultOption]="'' + this.pageSize" [label]="''" [idKey]="'pageSizeId'" [displayKey]="'pageSize'" [valueKey]="'pageSize'" [inputArray]="this.customPageSizes"></app-st-select-short>
&nbsp;&nbsp;<button type="button" class="btn st-button-primary rounded-pill" (click)="applyNewPageSize()">Reload Page</button>
<br>
<br>
<!--
<span><b>Results per page: </b></span><app-st-select-short [idVal]="this.idVal + '-page-size-dropdown-list-id'" [defaultOption]="'' + this.pageSize" [label]="''" [idKey]="'pageSizeId'" [displayKey]="'pageSize'" [valueKey]="'pageSize'" [inputArray]="this.customPageSizes"></app-st-select-short>
<button type="button" class="btn st-button-secondary" (click)="applyNewPageSize()">Reload Page</button>-->
<div role="group" aria-label="Paginator">
  <button type="button" class="btn st-button-secondary" (click)="this.navigateToFirstPage()">{{ this.lowerBoundary }}</button>
  <button type="button" class="btn st-button-secondary" (click)="this.navigateToPreviousPage()">{{ this.previousPage }}</button>
  <button *ngFor="let pageIndex of this.pagesDisplayed" class="btn" type="button" [ngClass]="pageIndex['classes']"
          (click)="updatePage(pageIndex['index'])"
  >{{pageIndex['index']}}</button>
  <button type="button" class="btn st-button-secondary" (click)="this.navigateToNextPage()">{{ this.nextPage }}</button>
  <button type="button" class="btn st-button-secondary" (click)="this.navigateToLastPage()">{{ this.upperBoundary }}</button>
</div>

<!--
<div class="btn-group st-button-group" role="group" aria-label="Paginator">
  <button type="button" class="btn btn-secondary" (click)="this.navigateToFirstPage()">{{ this.lowerBoundary }}</button>
  <button type="button" class="btn btn-secondary" (click)="this.navigateToPreviousPage()">{{ this.previousPage }}</button>
  <button *ngFor="let pageIndex of this.pagesDisplayed" class="btn btn-primary" type="button" [ngClass]="pageIndex['classes']"
          (click)="updatePage(pageIndex['index'])"
  >{{pageIndex['index']}}</button>
  <button type="button" class="btn btn-secondary" (click)="this.navigateToNextPage()">{{ this.nextPage }}</button>
  <button type="button" class="btn btn-secondary" (click)="this.navigateToLastPage()">{{ this.upperBoundary }}</button>
</div>
-->
